import { Fragment } from 'react'
import { Button, Modal } from '@opallabs/lapidary'

type ConfirmationBodyProps = {
  closeConfirmation: () => void
  discardAndClose: () => void
}

export const ConfirmationBody: React.FC<ConfirmationBodyProps> = ({
  closeConfirmation,
  discardAndClose,
}) => {
  return (
    <Fragment>
      <Modal.Title>Unsaved Changes</Modal.Title>
      <Modal.Body style={{ inlineSize: 432 }}>
        <Modal.Description>
          You have made changes that have not been saved. Do you want to discard
          them?
        </Modal.Description>
      </Modal.Body>
      <Modal.Footer>
        <Button
          buttonText="Cancel"
          name="Keep changes"
          onClick={closeConfirmation}
          variant="ghost"
        />
        <Button
          buttonText="Discard Changes"
          name="Discard changes"
          onClick={discardAndClose}
          variant="primary"
        />
      </Modal.Footer>
    </Fragment>
  )
}
